<template>
  <ams-table
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
    :filtering="filtering"
    :refresh="refresh"
    :refreshed="doRefresh"
    :reroute_name="reroute_name"
    :ams_template="ams_template"
  />
</template>

<script>
import AmsTable from './AmsTable.vue'

export default {
  components: {
    AmsTable
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      ams_type: 'profiles',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'ProfileCreateScreen',
      ams_fields: [
        { 
          key: 'attributes.nickname',
          label: 'Nickname',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.unique-alias',
          label: 'Alias ID',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.mobile',
          label: 'Mobile',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.location',
          label: 'Location',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc' 
        },
        {
          key: 'attributes.will-work',
          label: 'Will Work',
          sortable: true,
          filterable: true,
          sortDirection: 'asc'
        },
        {
          key: 'attributes.will-audit',
          label: 'Will Audit',
          sortable: true,
          filterable: true,
          sortDirection: 'asc'
        },
        { key: 'actions', label: 'Actions' }
      ],
      describe_belongs_to: [
        {
          prepend: ' ',
          type: 'users',
          description_attr: 'name',
          append: ' '
        },
        {
          prepend: ' of ',
          type: 'users',
          description_attr: 'email',
          append: ''
        }
      ]
    }
  },
  methods: {
    doRefresh() {
      this.emit('refreshed', true)
    }
  }
}
</script>